import { render, staticRenderFns } from "./page-intro.vue?vue&type=template&id=6bf04990&scoped=true"
import script from "./page-intro.vue?vue&type=script&lang=js"
export * from "./page-intro.vue?vue&type=script&lang=js"
import style0 from "./page-intro.vue?vue&type=style&index=0&id=6bf04990&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf04990",
  null
  
)

export default component.exports